var _style, _desc, _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYandexNavigator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 397.4 397.4",
    style: {
      enableBackground: "new 0 0 397.4 397.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:url(#Fill-1_1_);}.st1{fill:#FFCC00;}.st2{fill:#ECA704;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Color/icon_color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "Navi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color_x2F_icon_x5F_color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "navi",
    transform: "translate(56.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.589667, 0.993542)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Fill-1_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -540.1074,
    y1: 525.6934,
    x2: -539.1074,
    y2: 526.6934,
    gradientTransform: "matrix(397.4168 0 0 -397.4168 214590.1562 209259.7812)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCC00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFE992"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "st0",
    points: "339.8,-57 -57.6,104.5 116.3,166.6 178.4,340.4 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    className: "st1",
    points: "339.8,-57 110.1,172.8 178.4,340.4 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    className: "st2",
    points: "103.9,179 178.4,340.4 153.5,129.3 -57.6,104.5 "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexNavigator);
export default __webpack_public_path__ + "static/media/yandex_navigator_.81d9f82cab32e096786d812c9df7da4d.svg";
export { ForwardRef as ReactComponent };